import React from "react";
import { CustomButton } from "../button/button.component";
import DragSlider from "../drag-slider/drag-slider";
import { Section } from "../section/section.component";
import { GridCardSection, TextContainer } from "./drag-slider-section.styles";
import { base, containers } from "../../styles/base/_allBase.styles";
import { useParallaxInView } from "../../lib/hooks";
import { sanitySrcUrl } from "../../lib/libFunctions";
const { H2, StyleP, CenterDiv } = base;
const { Card, CardFooter } = containers;
import Content from "../block-content/block-content";
import { analyticsModuleAttributes } from "../../lib/analytics-content.mjs";

const DragSliderSection = React.memo(({ data }) => {
  const { y, ref, isInView } = useParallaxInView();
  const { header, text, array } = data;

  return (
    <Section
      cursorsize={"small"}
      size={"auto"}
      {...analyticsModuleAttributes(data, "drag_slider", undefined, header)}
    >
      <GridCardSection
        ref={ref}
        style={{ y, zIndex: 10, position: "relative" }}
      >
        <TextContainer style={{ y, zIndex: 100, position: "relative" }}>
          <CenterDiv>
            <H2 color="primary">{header}</H2>
            <StyleP color="primary">
              <Content blocks={text} />
            </StyleP>
          </CenterDiv>
        </TextContainer>
        <DragSlider>
          {array.map((item, i) => (
            <Card key={i} imgurl={sanitySrcUrl(item.photo)}>
              <CardFooter>
                <CustomButton
                  href={item.slug.current}
                  style={{ width: "80%" }}
                  data-analytics-cta-id={`${data?._key || "drag-slider"}-${i}`}
                  data-analytics-cta-label={item.label}
                  data-analytics-placement-id="drag-slider"
                >
                  {item.label}
                </CustomButton>
              </CardFooter>
            </Card>
          ))}
        </DragSlider>
      </GridCardSection>
    </Section>
  );
});

export default DragSliderSection;
